import { formatUnits } from 'ethers/lib/utils';
import { config } from '../../config/config';
import { EnabledChains, SupportedChains } from '../../config/constants';

type PriceFeedRes = {
    [tradePair: string]: {
        decimals: number;
        message: {
            price: string;
            createdOn: number;
            validTo: number;
        };
        priceFeedAddress: string;
        signature: string;
        signerAddress: string;
    };
};

const chainMapper: Record<EnabledChains[number], string> = {
    [SupportedChains.ARBITRUM_ONE]: 'arbitrum',
};

const priceFeedQuery = async (tradePair: string, chainId: EnabledChains[number]) => {
    const res = await fetch(
        `${config.urls.priceFeedApi}/priceFeedUnsigned/${tradePair.toLowerCase()}/${
            chainMapper[chainId]
        }`
    );

    const data: PriceFeedRes = await res.json();

    if (!data[tradePair]) throw new Error('PriceFeedQuery: TradePair does not exist');

    const { message, decimals } = data[tradePair];

    return formatUnits(message.price, decimals);
};

export default priceFeedQuery;
